import React from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalAnalytics } from '@atlassian/analytics-bridge';
import { toProjectType } from '@atlassian/jira-common-constants/src/project-types';
import { CONTROL, NOT_ENROLLED, VARIATION } from '@atlassian/jira-common-util-get-experiment-group';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common';
import { API_FAIL, PACKAGE_NAME, SUBJECT_EXPERIMENT_ID, TEAM_NAME } from './constants';
import { UpgradeOnboardingExperimentComponent } from './main';
import { getUpgradeOnboardingCohort, isSupportedProjectType } from './utils';

export const UpgradeOnboardingExperiment = () => {
	const { loading: loadingProject, data: project } = useProject();

	const projectType = project?.type && toProjectType(project.type);
	const cohort =
		(!loadingProject && projectType && getUpgradeOnboardingCohort(projectType)) || NOT_ENROLLED;

	const isUpgradeOnboardingEnabled = [CONTROL, VARIATION].includes(cohort);

	const { createAnalyticsEvent } = useAnalyticsEvents();

	if (!loadingProject && isSupportedProjectType(projectType) && isUpgradeOnboardingEnabled) {
		return (
			<JSErrorBoundary
				id={SUBJECT_EXPERIMENT_ID}
				fallback="unmount"
				onError={(err: string | undefined) => {
					fireOperationalAnalytics(
						createAnalyticsEvent({
							actionSubject: SUBJECT_EXPERIMENT_ID,
							action: API_FAIL,
						}),
						{ error: err },
					);
				}}
				teamName={TEAM_NAME}
				packageName={PACKAGE_NAME}
			>
				<UpgradeOnboardingExperimentComponent projectType={projectType} />
			</JSErrorBoundary>
		);
	}

	return null;
};
